import React from 'react';
import { Divider } from "antd"
import PropTypes from 'prop-types';
import { DarkerDivider } from "../../../CommonComponents/commonStyles";
import { ContainerCard, FlowCardGrid } from '../../../CommonComponents/FlowCard/styles';

export const trackGrids = (grid, cardRowWidth, firstRowGrids, borderBottomNoneQ) => {
    cardRowWidth += +grid.gridWidth;
    const ceilWidth = Math.ceil(cardRowWidth);
    if (firstRowGrids) {
        if (ceilWidth === 100) {
            cardRowWidth = 0;
            firstRowGrids = false;
        }
        return true;
    }
    if (borderBottomNoneQ.length && ceilWidth < 100) {
        return true;
    }
    if (ceilWidth === 100 && borderBottomNoneQ.length) {

        while (borderBottomNoneQ.length) {
            borderBottomNoneQ.shift();
        }
        cardRowWidth = 0;
        return true;
    }
    if (ceilWidth === 100) cardRowWidth = 0;
    return false;
}

const gridStyle = (width) => {
    return {
        width: `${width}%`,
    };
}
export const CardWapper = (props) => {
    const {
        cardConfig, styleConfig, index, stickyId,
    } = props;
    let cardRowWidth = 0;
    let firstRowGrids = true;
    const borderBottomNoneQ = [];

    if (!cardConfig) return <div>no data</div>;
    return (
        <ContainerCard
            data-test="transaction-card-wapper"
            bordered={styleConfig && styleConfig.cardBorder}
            cardParity={index}
            cardPadding={styleConfig && styleConfig.cardPadding}
            marginBottom={styleConfig && styleConfig.marginBottom}
            styleConfig={styleConfig}
        >
            {cardConfig.map((each, gridIndex) => {
                if (each.noBorderBottom) {
                    borderBottomNoneQ.push(each.name);
                }
                return (
                    <>
                        <FlowCardGrid
                            data-test="transaction-card-wapper-flow-card-grid"
                            id={stickyId || ''}
                            cardDetail={{
                                type: each.type,
                                gridWidth: each.gridWidth,
                                ptop: each.ptop,
                                pbottom: each.pbottom,
                                pleft: each.pleft,
                                pright: each.pright,
                            }}
                            style={gridStyle(each.gridWidth)}
                            borderNone={trackGrids(each, cardRowWidth, firstRowGrids, borderBottomNoneQ)}
                            key={gridIndex}
                            className={each.className || ''}
                        >
                            {each.render}
                        </FlowCardGrid>
                        {((gridIndex + 1) % 2) === 0 && cardConfig.length > gridIndex + 1 ? <Divider className="m20" /> : null}
                    </>
                );
            })}
            <DarkerDivider
                className={
                    props.dataIndex !== props.length - 1
                        && (props.styleConfig && props.styleConfig.cardDivider === false)
                        ? 'mt1 mb1'
                        : 'display-none'
                }
            />
        </ContainerCard>
    );
}

CardWapper.propTypes = {
    cardConfig: PropTypes.arrayOf(PropTypes.object),
    styleConfig: PropTypes.object
}

export default CardWapper;
